// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gap-2[data-v-4e206b2a]{gap:8px}.opacity-80[data-v-4e206b2a]{opacity:.85}.dir-ltr[data-v-4e206b2a]{direction:ltr;display:inline-block}", ""]);
// Exports
module.exports = exports;
